import * as React from 'react';

import { useSafeLayoutEffect } from './useSafeLayoutEffect';

/**
 * Exposes an API that is stable.
 * See it as a `useEventCallback` + `useMemo`.
 */
export function useAPI<T extends Record<string, any>>(value: T): T {
    const ref = React.useRef(value);
    useSafeLayoutEffect(() => {
        ref.current = value;
    });
    const [api] = React.useState(() => {
        return Object.keys(value).reduce<any>((proxy, key) => {
            if (typeof value[key] === 'function') {
                proxy[key] = (...args: any[]) => ref.current[key](...args);
            }
            return proxy;
        }, {} as any);
    });
    return api;
}
